import React from 'react';
import './NotificationBadge.css';

const NotificationBadge = ({ onClick, unreadCount = 0 }) => {
  return (
    <div className="notification-badge" onClick={onClick}>
      <span className="material-icons">notifications</span>
      {unreadCount > 0 && (
        <span className="badge-count">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  );
};

export default NotificationBadge; 